// extracted by mini-css-extract-plugin
export default {"root":"SupportChatPopup_root__ByFYv","widget":"SupportChatPopup_widget__Y8MBw","isOpen":"SupportChatPopup_isOpen__4q-bj","closeButton":"SupportChatPopup_closeButton__aSSu5"};